import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
const footerClassName = [
    "flex flex-wrap items-center justify-between gap-2",
    "border-t border-slate-200 bg-white px-4 py-2 text-sm text-slate-600 shadow-sm",
    "dark:border-slate-700 dark:bg-slate-900 dark:text-slate-300",
].join(" ");
const actionsClassName = "flex items-center gap-3 text-sm text-slate-500 dark:text-slate-300";
const AppFooter = ({ version, actions }) => {
    return (_jsxs("footer", { className: footerClassName, children: [_jsxs("span", { className: "font-medium", children: ["Version ", version] }), _jsx("div", { className: actionsClassName, children: actions })] }));
};
export default AppFooter;
